import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Modal} from 'antd';
import {getAttachment} from 'utils/attachment';


const LinksPopup = ({linksPopupVisible, setLinksPopupVisible}) => {
    const {storeData} = useSelector(state => state.fetchedData);     // homePopupLinks

    useEffect(() => {
        if (localStorage.getItem('linksPopupShowed')) {
            setLinksPopupVisible(JSON.parse(localStorage.getItem('linksPopupShowed')))
        } else {
            setLinksPopupVisible(storeData?.homePopup?.status)
        }
    }, [linksPopupVisible, storeData])

    const onCancel = () => {
        setLinksPopupVisible(false)
        localStorage.setItem('linksPopupShowed', false);
    }

    return (
        <Modal
            closable={false}
            visible={linksPopupVisible}
            maskClosable={false}
            centered={true}
            zIndex={9992}
            wrapClassName='linksPopupClass'
            bodyStyle={{height: window.innerWidth > 992 ? 'auto' : '89vh'}}
            footer={<h4 onClick={onCancel} className='text-center cursor-pointer' style={{textDecoration: 'underline'}}>
                Close
            </h4>}
        >   
            <div>
                <div className="linksPopupUserImg">
                    <img src={storeData?.homePopup?.logo === null ? "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png" : getAttachment(storeData?.homePopup?.logo)} alt={'#'}/>
                    <h4 className='mt-2'> {storeData?.homePopup?.title} </h4>
                </div>
                <div className='linksPopupBody'>
                    {storeData?.homePopupLinks?.map(item => 
                        <a href={item?.url} target={'_blank'} className="linksPopupContent" key={item.id}>
                            <img src={getAttachment(item?.logoId)} alt={item?.title}/>
                            {item?.title}
                        </a>)
                    }
                </div>
            </div>
        </Modal>
    )
}

export default LinksPopup;